import moment from 'moment'

import CHART_TYPES from '../../charts'
import NpsFilterOptions from '../../helpers/nps-filter-options'

export default {
  overviewWpEditor: {
    charts: [
      {
        type: CHART_TYPES.CARD,
        title: '# Saved Sites WordPress Editor',
        name: 'TotalCreatedSitesWordpressEditor'
      },
      {
        type: CHART_TYPES.CARD,
        title: '# Active Published Sites WordPress Editor',
        name: 'TotalActivePublishedSitesWordpressEditor'
      }
    ],
    route: '/financial-reports/wordpress-editor/overview'
  },
  publishedSitesWpEditor: {
    charts: [
      {
        type: CHART_TYPES.GRAPH,
        title: 'Saved sites WordPress Editor',
        name: 'CreatedSitesWordpressEditor',
        customerFormat: CHART_TYPES.BRAND_SITES,
        visible: ['WebsiteBuilder', 'BlueHost', 'Bluehost']
      },
      {
        type: CHART_TYPES.TABLE,
        title: 'New published sites WordPress Editor',
        name: 'NewPublishedWP',
        tooltip: 'Displays the newly published Wordpress Editor sites in the given timeframe. Note: only sites where the Publish button is clicked inside the WordPress Editor are displayed here.',
        sorting: { default: { fieldNames: ['TimePublished'], direction: false } }
      }
    ],
    route: '/financial-reports/wordpress-editor/published'
  },
  usageWpEditor: {
    charts: [
      {
        type: CHART_TYPES.HEAT_TABLE,
        title: 'Time to first publish',
        name: 'timetofirstpublishwordpressbh'
      },
      {
        type: CHART_TYPES.TABLE,
        title: 'Newest accounts',
        name: 'latestwordpressbuilderaccounts',
        limit: 500
      }
    ],
    route: '/financial-reports/wordpress-editor/usage'
  },
  satisfactionWpEditor: {
    charts: [
      {
        type: CHART_TYPES.TABLE,
        title: 'Satisfaction',
        name: 'NpsWPE',
        tooltip: 'A table with the scores and number of responses for the WordPress Editor',
        className: 'grid-col-6'
      },
      {
        type: CHART_TYPES.GRAPH,
        title: 'Satisfaction trend',
        name: 'NpsWPETrendsPerDay',
        tooltip: 'A graph with the satisfaction trend over time for the WordPress Editor'
      },
      {
        type: CHART_TYPES.CARD,
        title: 'Supporting comments',
        name: 'NpsWPESupportingCommentsTotal',
        tooltip: 'The total number of supporting comments for the WordPress Editor in the specified period'
      },
      {
        type: CHART_TYPES.TABLE,
        title: 'Satisfaction comments',
        name: 'NpsWPEComments',
        tooltop: 'A table showing all supporting comments for the WordPress Editor in the specified period',
        enableCaching: false,
        isNpsTable: true,
        filters: NpsFilterOptions,
        sorting: { default: { fieldNames: ['date'], direction: true } },
        headers: [
          {
            type: 'nps-multi-select',
            disableRouteClick: true
          },
          {
            name: 'AccountId',
            title: 'Account Id',
            type: 'account',
            disableRouteClick: true
          },
          {
            name: 'Email',
            title: 'Email',
            type: ''
          },
          {
            name: 'Phone',
            title: 'Phone',
            type: ''
          },
          {
            name: 'Partner',
            title: 'Partner',
            type: ''
          },
          {
            name: 'Score',
            title: 'Score',
            type: 'number'
          },
          {
            name: 'Comment',
            title: 'Comment',
            type: ''
          },
          {
            name: 'CustomerType',
            title: 'Customer Type',
            type: ''
          },
          {
            name: 'Date',
            title: 'Date',
            type: 'date'
          },
          {
            name: 'Time',
            title: 'Time',
            type: 'datetime'
          },
          {
            name: 'AgentId',
            title: 'Agent Id',
            type: ''
          },
          {
            name: 'Note',
            title: 'Note',
            type: ''
          },
          {
            name: 'Status',
            title: 'Status',
            type: ''
          },
          {
            type: 'nps-edit-column',
            disableRouteClick: true
          }
        ]
      }
    ],
    route: '/financial-reports/wordpress-editor/satisfaction'
  },
  wordPressEditorToday: {
    charts: [
      {
        className: 'grid-col-20',
        type: CHART_TYPES.CARD,
        title: 'These stats are updated every hour.'
      },
      {
        title: 'Total Users Created',
        type: CHART_TYPES.CARD,
        name: 'WordpressEditorAccountsCreatedToday',
        className: 'grid-col-4',
        tooltip: 'The total number of WordPress Editor users created today.',
        sourcedatabase: null
      },
      {
        title: 'New Paid Plans',
        type: CHART_TYPES.CARD,
        name: 'todaysnewhostingunits',
        className: 'grid-col-4',
        tooltip: 'Todays number of newly bought plans',
        sourcedatabase: 'reportinggator'
      },
      {
        title: 'Join Conversion',
        type: CHART_TYPES.CARD,
        name: 'WordpressEditorTodaysJoinConversion',
        className: 'grid-col-4',
        suffix: '%',
        tooltip: 'Todays percentage of newly bought plans relative to newly created Wordpress Editor accounts.'
      },
      {
        title: 'Cancels',
        type: CHART_TYPES.CARD,
        name: 'todayscancels',
        className: 'grid-col-4',
        tooltip: 'Todays number of cancelled plans',
        sourcedatabase: 'reportinggator'
      },
      {
        title: 'Total Revenue',
        type: CHART_TYPES.CARD,
        name: 'todaystotalrevenue',
        className: 'grid-col-4',
        prefix: '$',
        tooltip: 'Todays total revenue in $. Includes new Sales, Refunds, Renewals.',
        sourcedatabase: 'reportinggator'
      },
      {
        title: 'Sales / Renewals / Refunds',
        type: CHART_TYPES.PIE,
        name: 'todaysSalesRenewalsRefunds',
        tooltipLabel: 'items',
        customFormat: CHART_TYPES.PIE_WITH_PRICE,
        className: 'grid-col-4',
        tooltip: 'Todays ratio of new sales, renewals and refunds revenue',
        sourcedatabase: 'reportinggator'
      },
      {
        title: 'Todays transactions',
        type: CHART_TYPES.TABLE,
        name: 'todaystransactions',
        tooltip: [
          'Todays ratio of the different currency types for all new sales (no Refunds/Renewals)'
        ],
        className: 'grid-col-20',
        sorting: { default: { fieldNames: ['timestamp'], direction: false } },
        dontUseSourceDatabase: true,
        useBuilderPartnerFilter: true,
        start: moment()
          .subtract(1, 'd')
          .format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    ],
    gridSize: 20,
    route: '/financial-reports/wordpress-editor/today',
    disableToday: true,
    hideDatePicker: true,
    fixedPartnerId: 4101
  }
}
